import { call, put } from 'redux-saga/effects';
import { auth } from 'mz-sdk';
import posthog from 'posthog-js';
import { showNotification } from 'app/actions/notifications';
import { NOTIFICATION_ERROR } from 'app/constants';
import { removeCookie } from 'app/utils/cookie';

export default function* doLogout() {
  try {
    yield call(auth.logout);

    // Delete user data for third-party libs.
    window.mozioUser = null;
    posthog.reset();

    // Drop the shared TA locale preference so a later cold load resolves fresh.
    removeCookie('ta-locale');

    // Full-page reload so nginx routes / to the correct app (transfer-next on www.mozio.com).
    window.location.href = '/'; // eslint-disable-line require-atomic-updates
  } catch (error) {
    yield put(showNotification({
      type: NOTIFICATION_ERROR,
      message: error.message
    }))
  }
}
